<template>
    <div class="content mt20 bgfff">
       <div class="create-tasks">
           <div class="title">创建任务</div>
            <div class="form-group1 clearfix">
              <label class="control-label fw7 mt5">选择任务文章：</label>
              <div class="input-label active fl">
                  <div class="input-content w600">
                    <input type="text" class="input-text input-text1  w600" v-model="publicUrl" placeholder="请输入公众号文章链接，或者点击“添加素材”在素材中心选择" />
                    <span class="tasks-sure color-blue" @click="urlSure(2)">确定</span>
                  </div>
                  <div class="add-material-a color-blue mt10"  @click="addList(1)">
                     <span class="btn btn-blue"><i class="icons add-blue-icon"></i></span>添加素材
                  </div>
                  <div class="clearfix material-content mt20" :class="curr?'':'hide'">
                      <div class="fl profile-img"><img :src="arcdetail.newsImg" width="180" height="100"></div>
                      <div class="profile-info"><h3 class="profile-tit">{{arcdetail.newsTitle}}</h3></div>
                  </div>
              </div>
            </div>
            <div class="form-group1 clearfix">
              <label class="control-label fw7">指令类型：</label>
              <div class="clearfix fl">
                <div class="radio radio1 fl" @click="selClick(1)">
                  <input type="radio" v-model="sel" value="1"  class="radio-i">
                  <span class="radio-ico"></span>
                </div>
                <span>转发</span>
              </div>
              <div class="clearfix ml30 fl">
                <div class="radio radio1 fl" @click="selClick(2)">
                  <input type="radio" v-model="sel" value="2" class="radio-i">
                  <span class="radio-ico"></span>
                </div>
                <span>评论</span>
              </div>
              <div class="clearfix ml30 fl">
                <div class="radio radio1 fl" @click="selClick(3)">
                  <input type="radio" v-model="sel" value="3" class="radio-i">
                  <span class="radio-ico"></span>
                </div>
                <span>点赞</span>
              </div>
            </div>
            <div class="form-group1 clearfix">
              <label class="control-label fw7 mt30">选择任务对象 ：</label>
              <div class="input-label fl">
                <!--公众号-->
                  <ul class="article-ul clearfix" v-if="sel==1">
                      <li v-for="(item,index) in selectList" :key="index">
                          <div class="article-li">
                              <div class="account-img"><img :src="item.profileImgUrl" onerror="this.src='static/images/headImg.png'" /></div>
                              <a class="icons close-icon" href="javascript:void(0);" @click="delSelectUser(mediaIds,item.id,selectList);"></a>
                              <i class="icons" :class="platformImg[item.type-1]"></i>
                              <p class="fs12 ac">{{item.screenName}}</p>
                          </div>
                      </li>
                      <li class="last">
                          <div class="article-li cp" @click="addSendMedia();">
                              <div class="article-bigAdd">
                                  <i class="icons bigAdd-icon"></i>
                              </div>
                              <p class="fs12 ac color-blue">添加账号</p>
                          </div>
                      </li>
                  </ul>
                  <!--审核人-->
                  <ul class="article-ul clearfix" v-if="sel==2||sel==3">
                      <li v-for="(item,index) in peopleList" :key="index">
                          <div class="article-li">
                              <div class="account-img"><img :src="item.picurl" onerror="this.src='static/images/headImg.png'" /></div>
                              <a class="icons close-icon" href="javascript:void(0);" @click="delSelectUser(peopleIds,item.id,peopleList);"></a>
                              <p class="fs12 ac">{{item.nickname}}</p>
                          </div>
                      </li>
                      <li class="last">
                          <div class="article-li cp" @click="addPeople();">
                              <div class="article-bigAdd">
                                  <i class="icons bigAdd-icon"></i>
                              </div>
                              <p class="fs12 ac color-blue">添加账号</p>
                          </div>
                      </li>
                  </ul>

              </div>
            </div>
            <div class="form-group1 clearfix">
              <label class="control-label fw7 mt5">指令要求：</label>
              <div class="input-label fl">
                 <textarea class="w600 input-text" v-model="sel1" rows="31" placeholder="请输入指令要求"></textarea>
              </div>
            </div>
            <div class="btn-div mt40 ml20 clearfix">
                <button class="btn btn-blue fl" @click="define">提交</button>
                <button class="btn btn-white ml20 fl" @click="cancel">取消</button>
            </div>
       </div>
        <!-- 添加素材 -->
        <Dialog ref="materialModal" :callback="materialSave" width="520" height="500" class="content1" title="添加素材">
            <div slot="mdBox">
              <div class="materialContent">
                  <div class="search-warp">
                      <input type="text" name="search" placeholder="请输入标签名" class="input-text" v-model="keyWord"> 
                      <span class="search-btn" @click="mediaSearch();">
                          <i class="icons search-icon1"></i>
                      </span>
                  </div>
                  <div class="hotRecommed mt20">
                      <p class="t">热门文章推荐：</p>
                      <ul class="hotList mt10">
                        <li v-for="(item,index) in List" :class="active==index?'active':''" :key="index" @click="hotLiClick(item.id,index)">
                          <div class="ovhidden">{{item.newsTitle}}</div>
                        </li>
                      </ul>
                  </div>
              </div>
            </div>
        </Dialog>
        <!-- 选择发布媒体号 -->
        <mediaSelect ref="invitationToGroup" :dataArray="list2" :listPass='true' @userCallback="invitationToGroup" v-if="list2 != ''" title="选择任务对象"></mediaSelect>
        <!-- 添加审核人 -->
        <peopleSelect ref="peopleGroup" :dataArray="list1" :line='true' :listPass='true' @peopleCallback="peopleSave" v-if="list1 != ''" title="选择任务对象"></peopleSelect>
  	
  	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import mediaSelect from '../../components/mediaSelect.vue';
import peopleSelect from '../../components/peopleSelect.vue';
export default {
   components:{Dialog,mediaSelect,peopleSelect},
    data() {
        return {
           List:'',//添加素材弹框列表
           publicUrl:'',//公众号文字url
           keyWord:'',//搜索关键词
           typeOrder:1,//文章地址 素材 类型
           OrderContent:'',//文章地址 素材
           active:-1,
           arcdetail:'',//文章信息
           curr:false,//文章信息 是否显示
           Id:'',//id
           sel:1,//绑定数据
           sel1:'',//指令要求
          // WxAccountid:[],//指令类型
          // AccountidUser:'',//
          tipsText:'任务文章、任务类型和任务对象为必填项，请重新填写!',//提示文字
          platformImg:['wx-icon','wb-icon','tt-icon'],
          articleId:'',
          success:false,//控制发布状态显示
          second:6,//倒计时
          list1:[],//审核人列表
          list2:[],//媒体列表
          mediaIds:[],//账户id
          peopleIds:[],//账户id
          selectList:[],//已选列表
          peopleList:[],//已选用户列表
          Id:'',//选择素材id


        }
    },
    mounted() {
      let that = this;
      that.dataAjax2();
      that.$nextTick(()=> {
          that.articleId = that.$route.query.id;
          that.getUesrList();
          that.getMediaList();
      })
      
    },
    created() {
		
    },
    methods: {
        selClick(type){//切换指令类型
          let that= this;
          that.sel = type;
          
        },
        define(){//确定
          let that = this;
          let url = 'order/save';
            if(that.OrderContent == ''||that.mediaIds ==''){
              that.$utils.alertText(that.tipsText,400,3000);
              return;
            }
            that.$api.post(url,{mid:that.Id,type:that.sel,accountid:that.mediaIds,remark:that.sel1},r=>{
                that.$parent.returnCode(r,function(){
                    that.$router.push({
                        path: '/taskOrders/issueOrders',
                    });
                })
            });
          
        },
        cancel(){//取消
          this.$router.push({
              path: '/taskOrders/issueOrders',
          });
        },
        mediaSearch(){//搜索
          this.dataAjax2();

        },
        urlSure(type){//点击公众号url
          let that =this;
          that.curr = true;
          that.typeOrder = type;
          that.OrderContent = that.publicUrl;
          if(that.OrderContent==''){
            that.curr = false;
            return;
          }
          that.dataAjax();
        },
        hotLiClick(id,index){//弹框点击选择
          let that = this;
          that.Id = id;
          that.OrderContent = that.Id;
          that.active = that.active == index ? -1 : index; 
        },
        addList(type){//添加素材弹框
            this.typeOrder = type;
            this.dataAjax2();
            this.$refs.materialModal.showMaskFun();
        },
        materialSave(){//弹框返回
          let that =this;
          that.dataAjax();
          if(that.Id==''){
            return;
          }
          that.curr = true;
          this.$refs.materialModal.closeMask();
        },
        dataAjax(){//素材列表
            let that = this;
            let url = '/order/arcdetail';
            that.$api.post(url,{type:that.typeOrder,content:that.OrderContent},r=>{
                that.$parent.returnCode(r,function(){
                  that.arcdetail = r.data;
                  that.Id = r.data.id;
                })
            })
       },
       dataAjax2(){//素材详情
            let that = this;
            let url = '';
            that.$api.post('/order/arclist',{title:that.keyWord},r=>{
                that.$parent.returnCode(r,function(){
                    that.List=r.data;
              })
            })
       },
       // 获取账户列表
        getUesrList () {
            let that = this;
            let url = 'user/checklist';
            that.allIds = [];
            that.$api.post(url, {search:''}, r => {
                that.$parent.returnCode(r,function(){
                    that.list1 = r.data;
                })
            })
        },
        // 获取媒体列表
        getMediaList () {
            let that = this;
            let url = 'member/publishlist';
            that.$api.post(url, null, r => {
                that.$parent.returnCode(r,function(){
                    that.list2 = r.data;
                })
            })
        },
        // 添加发布账号
        addSendMedia () {
            this.$refs.invitationToGroup.synchroPublicNumber(2);
            this.$refs.invitationToGroup.mediaIds = this.mediaIds;
        },
        invitationToGroup (val) {
            this.mediaIds = val[0];
            this.selectList = val[1];
        },
        // 
        addPeople () {
            this.$refs.peopleGroup.synchroPublicNumber();
            this.$refs.peopleGroup.mediaIds = this.peopleIds;
        },
        // 保存选择人
        peopleSave (val) {
           this.mediaIds = this.peopleIds = val[0];
            this.peopleList = val[1];
            
        },
        // 删除已选发布媒体号
        delSelectUser (ids,id,list) {
            let mediaIds = ids;
            let selectList = list;
            let index = '';
            for(let i in selectList){
                if(id === selectList[i].id){
                    index = i;
                }
            }
            selectList.splice(index,1);
            mediaIds.splice(index,1);
        } 
  },
}
</script>



// WEBPACK FOOTER //
// src/page/taskOrders/createTasks.vue